import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {routes} from '../routes';

interface FAQItem {
    question: string;
    answer: React.ReactNode;
    category: string;
}

const FaqPage: React.FC = () => {
    const [openItems, setOpenItems] = useState<number[]>([]);

    const toggleItem = (index: number) => {
        setOpenItems(prev =>
            prev.includes(index)
                ? prev.filter(item => item !== index)
                : [...prev, index]
        );
    };

    const faqData: FAQItem[] = [
        // Información Básica
        {
            category: "Información Básica",
            question: "¿Habrá enchufes para conectar mis dispositivos (celular, plancha, secadora para cabello, etc.)?",
            answer: "Sí, pero serán limitados dentro de un área designada, considera llevar tu batería portátil y lo que necesites con suficiente pila. En los baños podrán conectar su secadora y/o plancha para el cabello."
        },
        {
            category: "Información Básica",
            question: "¿Habrá conexión a internet?",
            answer: "Sí, contaremos con conexión satelital (SpaceX), sin embargo, queremos disfrutar contigo la naturaleza y vivir el momento, esperamos que no sea tan indispensable el internet."
        },
        {
            category: "Información Básica",
            question: "¿Hay conexión de datos móviles?",
            answer: "Depende de la compañía de celular que tengas. Por el momento hemos visto que Movistar y Telcel tienen conexión muy limitada y sólo en ciertas áreas."
        },
        {
            category: "Información Básica",
            question: "¿Cómo llego al lugar de la boda?",
            answer: "Desde la Ciudad de México tomando la salida a Cuernavaca, a la altura de Tres Marías tomas la carretera rumbo a Huitzilac y queda del lado izquierdo de la avenida."
        },
        {
            category: "Información Básica",
            question: "¿A qué hora puedo llegar el viernes o el sábado?",
            answer: "El viernes puedes llegar desde las 3 pm, pero si llegas más tarde no hay problema; puedes incluso llegar después de la cena (7 pm). Si llegas el sábado, te recomendamos llegar a partir de la 1 pm, ya que la ceremonia religiosa inicia a las 2 pm."
        },
        {
            category: "Información Básica",
            question: "¿Habrá estacionamiento disponible?",
            answer: "Sí, contamos con estacionamiento gratuito en el lugar."
        },
        {
            category: "Información Básica",
            question: "¿Hay seguridad en el lugar?",
            answer: "Sí, el venue cuenta con seguridad. Al momento de que ya no se esperen más invitados, se cerrarán las puertas."
        },
        {
            category: "Información Básica",
            question: "¿Hay lugar para bañarme si me quedo a dormir?",
            answer: "Sí, el venue cuenta con regaderas tipo vestidor y agua caliente."
        },
        {
            category: "Información Básica",
            question: "¿Qué hay cerca del venue por si necesito algo de último momento?",
            answer: "Nada, considera que el pueblo más cercano al venue es Huitzilac, en el cual no hay muchos negocios populares. Es recomendable que hagas una lista para que no olvides nada y no tengas que salir durante el evento del venue."
        },
        {
            category: "Información Básica",
            question: "¿El venue tiene primeros auxilios disponibles?",
            answer: "Sí."
        },

        // Código de Vestimenta
        {
            category: "Código de Vestimenta",
            question: "¿Qué debo usar? ¿Cuál es el código de vestimenta?",
            answer: (
                <>
                    El código de vestimenta es formal. Para ellas: vestido largo elegante en tonos oscuros. Evita tacones de aguja por el entorno natural. Para ellos: traje completo con corbata/moño. Revisa los colores en el <Link to={routes.DressCode} className="underline text-[#8a2c47]">código de vestimenta</Link>.
                </>
            )
        },
        {
            category: "Código de Vestimenta",
            question: "¿Qué colores debo evitar?",
            answer: (<> Por favor evita el blanco, marfil y tonos muy claros que puedan competir con el vestido de la novia. Revisa nuestra página del <Link to={routes.DressCode} className="underline text-[#8a2c47]">código de vestimenta</Link> para más información. Si aún tienes dudas por favor no dudes en contactarnos.</>)
        },
        {
            category: "Código de Vestimenta",
            question: "¿Hará frío? ¿Necesito abrigo?",
            answer: "Sí, es lo más probable. La boda será en zona de bosque y por la noche hace frío. Te recomendamos llevar un abrigo, chal o saco grueso para mantenerte cómodo. Incluso si quieres llevar mallones (debajo del vestido) o botas puede ser buena idea."
        },

        // Regalos
        {
            category: "Regalos y Mesa de Regalos",
            question: "¿Tienen mesa de regalos?",
            answer: "Sí, tenemos opciones de mesa de regalos. Preferimos contribuciones monetarias (en sobre), pero también tendremos una mesa especial en Liverpool."
        },
        {
            category: "Regalos y Mesa de Regalos",
            question: "¿Puedo dar mi regalo en efectivo el día de la boda?",
            answer: "¡Por supuesto! Habrá una mesa especial para sobres en la recepción. También puedes hacer transferencia bancaria antes del evento si prefieres."
        },
        {
            category: "Regalos y Mesa de Regalos",
            question: "¿Cuáles son los datos para transferencia bancaria?",
            answer: "Preferimos una contribución en sobre o a través de la mesa de regalos de Liverpool, pero si de todas formas prefieres realizar una transferencia, comunícate directamente con nosotros y te proporcionaremos los datos."
        },


        // Comida y Bebidas
        {
            category: "Comida y Bebidas",
            question: "¿Qué tipo de comida habrá?",
            answer: (<>Tendremos un menú de tres tiempos, pero queremos que sea sorpresa. Habrá opciones vegetarianas y veganas disponibles, pero por favor indica tus restricciones dietéticas en la sección de <Link to={routes.RSVP} className="underline text-[#8a2c47]">RSVP</Link> para tenerlo en cuenta.</>)
        },
        {
            category: "Comida y Bebidas",
            question: "¿Habrá alcohol en la boda?",
            answer: "¡Absolutamente! Nosotros nos encargamos de una parte de la selección de bebidas."
        },
        {
            category: "Comida y Bebidas",
            question: "Tengo alergias/restricciones alimentarias, ¿qué hago?",
            answer: (<>Por favor indícanos tus restricciones alimentarias en el <Link to={routes.RSVP} className="underline text-[#8a2c47]">RSVP</Link> o contáctanos directamente. Nuestro catering puede acomodar la mayoría de las necesidades especiales.</>)
        },
        {
            category: "Comida y Bebidas",
            question: "¿Habrá opciones de alimentos para niños?",
            answer: "Sí, si tienes dudas de los alimentos en específico, contáctanos."
        },
        {
            category: "Comida y Bebidas",
            question: "¿Puedo llevar mi propia botella de vino/licor?",
            answer: "Sí, lleva lo que más te guste para tu mesa y/o consumo personal. Puedes ponerle una etiqueta para que el personal la identifique."
        },

        // RSVP y Invitados
        {
            category: "RSVP y Invitados",
            question: "¿Hasta cuándo puedo confirmar mi asistencia?",
            answer: "Por favor confirma tu asistencia antes del 15 de Enero. Esto nos ayuda enormemente con la planificación del catering y la organización."
        },
        {
            category: "RSVP y Invitados",
            question: "¿Puedo cambiar mi confirmación después de haberla enviado?",
            answer: "Sí, pero en cuanto realicemos la segunda fase de confirmación, ya no podrás modificarla. Por favor avísanos de tu situación lo más pronto posible para que podamos prepararnos adecuadamente."
        },
        {
            category: "RSVP y Invitados",
            question: "¿Puedo llevar a mi pareja/un acompañante?",
            answer: "Si tu invitación incluye más de un pase o menciona específicamente a tu pareja, ¡por supuesto! Si tienes dudas, no dudes en contactarnos."
        },
        {
            category: "RSVP y Invitados",
            question: "¿Los niños son bienvenidos?",
            answer: "No lo recomendamos debido a que el venue es un espacio muy amplio y pueden perderse. Es responsabilidad de los padres cuidar a sus propios hijos y evitar cualquier posible situación no deseada, incluyendo que se estropee algún video o foto importante, así como cuestiones de seguridad para el niño y/o para otros invitados. Si quieres llevar a tu hijo/a avísanos primero, por favor."
        },

        // Logística
        {
            category: "Logística",
            question: "¿Habrá transporte desde alguna ubicación?",
            answer: "No tenemos transporte organizado, estamos buscando alternativas, comunícate con nosotros para más información, por el momento te sugerimos coordinarte con otros invitados para compartir transporte."
        },
        {
            category: "Logística",
            question: "¿Qué hoteles recomiendan cerca del venue?",
            answer: "No recomendamos hoteles ya que se encuentran lejos y se tendrían que mover a través de la carretera de noche. Sugerimos que busquen una opción de Airbnb cercana. Sin embargo, conocemos estos hoteles cerca que pueden tener en cuenta: GS Hotel Cuernavaca (a 30 minutos por la de cuota), One o Fiesta Inn Cuernavaca (a 35 minutos por la de cuota) y Hotel Racquet Cuernavaca (a 33 minutos por la de cuota)."
        },
        {
            category: "Logística",
            question: "¿Debo llevar algo específico si me quedo a dormir?",
            answer: "Sólo serán necesarios tus artículos de higiene personal y tu pijama. Si eres muy friolenta/o considera traer una cobija adicional y un gorro para dormir."
        },
        {
            category: "Logística",
            question: "¿Qué pasa si llueve?",
            answer: "La celebración es en una carpa donde no nos mojaremos, pero el piso puede estar húmedo. Sin importar el clima, ¡la fiesta continuará! Si te quedas a dormir: las tiendas de acampar son completamente impermeables, no tendrás problema con el agua ya que estaremos bien resguardados."
        },
        {
            category: "Logística",
            question: "¿Hasta qué hora es la fiesta?",
            answer: "La fiesta oficial termina a la 1 am (el servicio de música y meseros), pero esperamos disfrutar juntos hasta que salga el sol. El venue estará disponible toda la noche."
        },
        {
            category: "Logística",
            question: "¿Puedo llevar mi propia tienda de acampar?",
            answer: "No, sólo contamos con el permiso para las tiendas tipo glamping."
        },
        {
            category: "Logística",
            question: "¿Hasta qué hora puedo quedarme el domingo?",
            answer: "A las 12 pm se debe realizar el check-out de las cabañas. Por lo que alrededor de la misma hora estaremos desalojando el venue."
        },

        // Contacto
        {
            category: "Contacto",
            question: "¿Habrá hashtag oficial para compartir fotos en redes sociales?",
            answer: "No lo tenemos considerado todavía, si tienes una buena idea ¡compártela con nosotros!"
        },
        {
            category: "Contacto",
            question: "¿Puedo traer a mi mascota?",
            answer: "No."
        },
        {
            category: "Contacto",
            question: "¿Puedo tomar fotos durante la ceremonia?",
            answer: "Preferimos una ceremonia 'desconectados' - nuestros fotógrafos profesionales capturarán todos los momentos especiales. Durante la recepción, ¡toma todas las fotos que quieras!"
        },
        {
            category: "Contacto",
            question: "¿A quién contacto si tengo más preguntas?",
            answer: "Puedes contactar directamente a Eli (5515271633) y/o a Lalo (5534740861)."
        }
    ];

    const categories = Array.from(new Set(faqData.map(item => item.category)));

    return (
        <div className="min-h-screen bg-[#8a2c47] z-5 bg-cover bg-fixed text-white">
            <video
                className="inset-0 w-lvw h-lvh object-cover fixed z-10"
                style={{mixBlendMode: 'multiply'}}
                autoPlay loop muted playsInline>
                <source src="/Leaves.mp4" type="video/mp4"/>
                Your browser does not support the video tag.
            </video>
            <div className="container relative mx-auto px-4 max-w-2xl pb-20 items-center z-20">
                <div className="text-center">
                    <h2 className="text-[30pt] md:text-[45pt] font-bold pt-20">Preguntas Frecuentes</h2>
                    <p className="mb-10">
                        ¿Tienes dudas sobre nuestra boda? Aquí encontrarás respuestas a las preguntas más comunes.
                        Si no encuentras lo que buscas, ¡no dudes en contactarnos directamente!
                    </p>
                </div>

                {/* FAQ Content by Categories */}
                {categories.map((category, categoryIndex) => {
                    return (
                        <div key={categoryIndex} className="mt-10">
                            <div className="text-center mb-6">
                                <h2 className="text-white text-2xl text-center font-bold">
                                    {category}
                                </h2>
                            </div>
                            <div className="space-y-4">
                                {faqData
                                    .filter(item => item.category === category)
                                    .map((faq, index) => {
                                        const globalIndex = faqData.indexOf(faq);
                                        const isOpen = openItems.includes(globalIndex);
                                        return (
                                            <div
                                                key={globalIndex}
                                                className="bg-[#f2ece7] text-[#606060] rounded-lg border overflow-hidden hover:border-gray-600 transition-colors"
                                            >
                                                <button
                                                    onClick={() => toggleItem(globalIndex)}
                                                    className="w-full p-4 sm:p-6 text-left flex justify-between items-center hover:bg-gray-800/20 transition-colors"
                                                >
                                                    <h3 className="text-[#606060] font-bold pr-4">
                                                        {faq.question}
                                                    </h3>
                                                    <span
                                                        className={`text-2xl text-[#f78c49] transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`}>
                                                        +
                                                    </span>
                                                </button>

                                                <div
                                                    className={`grid transition-[grid-template-rows] duration-300 ease-out ${
                                                        isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
                                                    }`}
                                                >
                                                    <div className="overflow-hidden">
                                                        <div className="px-4 sm:px-6 pb-4 sm:pb-6">
                                                            <div className="pt-4 border-t border-gray-700">
                                                                <div className="text-sm text-[#606060]">
                                                                    {faq.answer}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    );
                })}
                <img src={"/images/Grid-FAQ.png"} alt={"Hospedaje"} className="mt-10 mb-10 w-[90%] mx-auto"/>
            </div>
        </div>
    );
};

export default FaqPage;